import React from 'react';
import { Badge } from 'reactstrap';
import { FaTimes, FaFile, FaImage, FaMusic, FaFilm, FaFilePdf, FaFileAlt } from 'react-icons/fa';

function FileBadges({fileType, fileName, handleRemoveFile}) {
  const fileIcon = (fileType) => {
    if (fileType?.startsWith('image')) return <FaImage />;
    if (fileType?.startsWith('audio')) return <FaMusic />;
    if (fileType?.startsWith('video')) return <FaFilm />;
    if (fileType === 'application/pdf') return <FaFilePdf />;
    if (fileType?.includes('text')) return <FaFileAlt />;
    return <FaFile />;
  };

  return (
        <Badge color="secondary" pill className="mr-2">
          {fileIcon(fileType)} {fileName} 
          <FaTimes onClick={handleRemoveFile} style={{ cursor: 'pointer', marginLeft: '5px' }}/>
        </Badge>
      )
}

export default FileBadges;